import {createAction, handleActions} from 'redux-actions';

const UPDATE = '@nezzokontikifrontend/Filter/UPDATE';
const COUNT = '@nezzokontikifrontend/Filter/COUNT';
const PAGINATE = '@nezzokontikifrontend/Filter/PAGINATE';
const REMAINING = '@nezzokontikifrontend/Filter/REMAINING';

export const actionTypes = {
	UPDATE,
	COUNT,
	PAGINATE,
	REMAINING,
};

const update = createAction(UPDATE, (filter, pagination) => {
	return {filter: filter, pagination: pagination}
});
const count = createAction(COUNT, filter => filter);
const paginate = createAction(PAGINATE, (filter, pagination) => {
	return {filter: filter, pagination: pagination}
});
const remaining = createAction(REMAINING, remainingData => remainingData);

export const actions = {
	update,
	count,
	paginate,
	remaining,
};

const defaultState = {
	filter: {
		tags: [],
		logicalOperator: 1,
		contentTypes: ''
	},
	pagination: {
		limit: 10,
		offset: 0,
		moreData: true
	}
};

export const reducer = handleActions({
	[UPDATE]: (state, action) => {
		return {...state, filter: {...state.filter, ...action.payload.filter}, pagination: {...state.pagination, ...action.payload.pagination}}
	},
	[COUNT]: (state, action) => {
		return {...state, filter: {...state.filter, ...action.payload}}
	},
	[PAGINATE]: (state, action) => {
		return {...state, pagination: {...state.pagination, offset: action.payload.pagination.offset}}
	},
	[REMAINING]: (state, action) => {
		return {...state, pagination: {...state.pagination, moreData: action.payload}}
	}
}, defaultState);


// WEBPACK FOOTER //
// ./src/reducers/filter.js